import React, { useState } from "react";
export const ExploreButton = ({ label, onClick, ariaLabel }) => {
  const [buttonText, setButtonText] = useState(label);

  onClick = onClick || (() => {
    setButtonText("Exploring...");
  });
  return (
    <button
      type="button"
      className="action-btn"
      onClick={onClick}
      aria-label={ariaLabel || label}
    >
      {buttonText} <span className="chev">›</span>
    </button>
  );
};